import { render } from "./App.vue?vue&type=template&id=03ee98ac&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=03ee98ac&scoped=true&lang=css"

import exportComponent from "/Users/alexvoina/Development/myhouse-booking-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ee98ac"]])

export default __exports__